// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BigManagementSystem_wrapper__3sbPb"};